import { Fragment, useEffect, useState } from "react";
import {
  Dialog,
  Transition,
} from "@headlessui/react";
import Select from "react-select";
import { CATEGORY, endpoints } from "../../api/endpoints";
import Api_Instance from "../../api/Api_Instance";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCategoryid, setFilter } from "../../redux/slice/Slice";
import toast from "react-hot-toast";
import { INVESTMENT_RANGE, STATE_DATA } from "../../utils/Utils";
import { debounce } from "lodash";
import { IoSearch } from "react-icons/io5";

function HomeSearch({ Isopen, open, isSticky }) {
  const api = Api_Instance.unAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [filterdata, setFilterdata] = useState([]);
  const [categorydata, setCategoryData] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [formValues, setformValues] = useState({
    state: "",
    category: "",
    subcategory: "",
    price: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const debouncedErrorToast = debounce(() => {
    toast.error("No data found");
  }, 500);
  const getFilterata = async (e) => {
    e?.preventDefault();
    // const hasInvalidData = Object.values(formValues).some(
    //   (item) => item === undefined
    // );

    // if (hasInvalidData) {
    //   debouncedErrorToast();
    //   return;
    // }

    try {
      const res = await api("GET", endpoints.BUSSINESS_API, null, formValues);
      setFilterdata(res?.data?.data);
      dispatch(setFilter(res?.data?.data));
      dispatch(setCategoryid(formValues));
      Isopen(false);
      console.log(   res?.data?.data?.length, res?.data)
      if (res.status === 200 && res?.data?.status) {
    
        res?.data?.data?.length && navigate("/products/best-bussiness");
      } else {
        dispatch(setFilter([]));
        toast.error(res?.data?.errors);
        return;
      }
    } catch (error) { }
  };
  const cateGoryApi = async () => {
    try {
      const res = await api("GET", CATEGORY.GET_CATEGORY);
      setCategoryData(res?.data?.data);
    } catch (error) { }
  };


  useEffect(() => {
    cateGoryApi();
  }, []);
  useEffect(() => {
  }, [formValues.category]);
  useEffect(() => {
    const data = categorydata.filter((category) =>
      category.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setformValues((prev) => ({
      ...prev,
      category: data[0]?.id,
    }));
  }, [searchTerm]);

  const handleSearchChange = (selectedOption) => {
    setSearchTerm(selectedOption ? selectedOption.value : "");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      getFilterata()
      const selectedCategory = filteredCategories;
      if (selectedCategory) {

        // navigate("  /products/best-bussiness");
      }
    }
  };

  const categories = categorydata;
  const subcategories = subcategory;
  const locations = STATE_DATA;
  const investments = INVESTMENT_RANGE;
  return (
    <Transition show={open}>
      <Dialog className="relative z-10" onClose={Isopen}>
        <Transition.Child
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className={`absolute ${isSticky ? "top-[5px]" : "top-[34px]"} transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full md:w-[100%] z-50`}>
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="max-w-[600px] mx-auto">
                    <div className="relative border-2 border-[#0097c5] rounded-lg">
                      <Select
                        value={{ value: searchTerm, label: searchTerm }}
                        onChange={handleSearchChange}
                        options={categorydata.map((item) => ({
                          value: item.name,
                          label: item.name,
                        }))}
                        onKeyDown={handleKeyDown}
                        isSearchable={true}
                        placeholder="Search and navigate..."
                      />
                      <span
                        className="absolute top-1/2 right-1 transform -translate-y-1/2 bg-white border-l border-[#c2c1c1] ps-[8px]"
                        onClick={(e) => getFilterata(e)}
                      >
                        <IoSearch className="text-secondaryColor text-[28px]" />

                      </span>
                    </div>
                  </div>
                  <p className="text-red-600 flex justify-center mt-4">
                    Or Explore By
                  </p>
                  <div className="static w-full flex justify-center items-center mt-1">
                    <div className="  p-1.5 md:p-3rounded-md">
                      <form onSubmit={getFilterata}>
                        <div className="flex w-full flex-col md:flex-row justify-between md:gap-2 lg:gap-4">
                          {[
                            {
                              placeholder: "Select Category",
                              options: categories,
                              fieldname: "category",
                            },
                            // {
                            //   placeholder: "Select Subcategory",
                            //   options: subcategories,
                            //   fieldname: "subcategory",
                            // },
                            {
                              placeholder: "Select Location",
                              options: locations,
                              fieldname: "state",
                            },
                            {
                              placeholder: "Select Investment",
                              options: investments,
                              fieldname: "price",
                            },
                          ].map((select, index) => (
                            <div
                              key={index}
                              className="w-full md:w-[22%] lg:w-[180px] mb-2 md:mb-0 xl:flex-wrap"
                            >
                              <select
                                name={select.fieldname}
                                onChange={(e) => handleChange(e)}
                                className="block rounded-md border border-[#d1d5db] shadow-sm p-3 text-xs sm:text-sm bg-white text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                              >
                                <option value="" disabled selected hidden>
                                  {select.placeholder}
                                </option>
                                {select.options.map((option, i) => (
                                  <option
                                    key={i}
                                    value={select.fieldname === "price" ? option.value : option?.id}
                                    data-name={"data-name"}
                                  >
                                    {option.name ? option.name : select.fieldname === "price" ? option.label : option.value}
                                  </option>
                                ))}
                              </select>
                            </div>
                          ))}
                          <div className="w-full xl:w-36 md:w-[22%] md:ml-2 lg:ml-0">
                            <button
                              type="submit"
                              className=" [transition:all_.15s_ease-in-out] hover:[box-shadow:0_0_10px_0_#0098c6_inset,_0_0_20px_2px_#0096c48c] inline-flex justify-center w-full rounded-md border text-white border-[#d1d5db] shadow-sm px-3 py-3 sm:px-4 sm:py-2 bg-primaryColor text-xs sm:text-sm font-medium "
                            >
                              Search
                            </button>
                          </div>
                        </div>
                      </form>
                      {/* <div className="flex w-full flex-col md:flex-row flex-wrap justify-between gap-2 ">
                        {[
                          "Select Category",
                          "Select Subcategory",
                          "Select Location",
                          "Select Investment",
                        ].map((placeholder, index) => (
                          <div
                            key={index}
                            className="relative w-full md:w-[170px] xl:w-[150px]"
                          >
                            <input
                              type="text"
                              placeholder={placeholder}
                              className="block w-full rounded-md border border-gray-300 shadow-sm p-3 text-xs sm:text-sm bg-white text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <FontAwesomeIcon
                              icon={faChevronDown}
                              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                            />
                          </div>
                        ))}
                        <div className="w-full md:w-32">
                          <button
                            type="button"
                            className="inline-flex justify-center w-full rounded-md border text-white border-gray-300 shadow-sm px-3 py-3 sm:px-4 sm:py-2 bg-[#1072B8] text-xs sm:text-sm font-medium hover:bg-gray-500"
                          >
                            Search
                          </button>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 flex justify-center mt-4 space-x-4 p-4">
                  <button
                    type="button"
                    className="inline-flex w-full h-10 justify-center rounded-md bg-primaryColor px-3 py-2 text-sm font-semibold text-white md:w-40 ![transition:all_.15s_ease-in-out] !hover:[box-shadow:0_0_10px_0_#0098c6_inset,_0_0_20px_2px_#0096c48c]"
                    onClick={() => getFilterata()}
                  >
                    Explore
                  </button>
                  <button
                    type="button"
                    className="inline-flex w-full  h-10 justify-center rounded-md bg-[#c2c1c1] text-white px-3 py-2 text-sm font-semibold  shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-[#E8E8E8] md:w-40"
                    onClick={() => { setSearchTerm("") }}
                    data-autofocus
                  >
                    Clear All
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default HomeSearch;
